<template>
    <div class="section-row tx-odu-mediacentre--list -padded-wide">
        <div class="col-wrapper -max-width-limited" v-if="!filtersFixed && ((!hideProductFilter && products.length) || (!hideIndustryFilter && industries.length) || (!hideTypeFilter && types.length))">
            <div class="module-filter-form">
                <form class="filter-form__form" @submit.prevent="submit()">
                    <div class="form-wrapper -bg-white">
                        <div class="col selectbox" v-if="!hideProductFilter && products.length">
                            <CheckboxFilter
                                    identifier="products"
                                    :label="$t('search.products')"
                                    :options="mutatedProducts"
                                    v-model="selectedProducts"/>
                        </div>
                        <div class="col selectbox" v-if="!hideIndustryFilter && industries.length">
                            <div class="form-group selectbox">
                                <div class="input">
                                    <select class="form-control -filled" id="searchIndustry" v-model="selectedIndustry">
                                        <option value="-1">{{ $t('search.industries') }}</option>
                                        <option v-for="(industry, key) in industries" :value="industry.uid.toString()" :key="key">
                                            {{ industry.name }}
                                        </option>
                                    </select>
                                    <div class="input-background">
                                        <label class="control-label" for="searchIndustry"></label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col selectbox" v-if="!hideTypeFilter && types.length">
                            <div class="form-group selectbox">
                                <div class="input">
                                    <select class="form-control -filled" id="searchIndustry" v-model="selectedType">
                                        <option value="-1">{{ $t('search.types') }}</option>
                                        <option v-for="(type, key) in types" :value="type.uid.toString()" :key="key">
                                            {{ type.name }}
                                        </option>
                                    </select>
                                    <div class="input-background">
                                        <label class="control-label" for="searchIndustry"></label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
                <div class="filter-form__selected" v-if="(!hideProductFilter && selectedProducts.length) || (!hideIndustryFilter && selectedIndustry != -1) || (!hideTypeFilter && selectedType != -1)">
                    <div class="selected__wrapper">
                        <template v-if="!hideProductFilter">
                            <div class="selected__item"
                                 v-for="product in products.filter(item => selectedProducts.includes(item.uid))"
                                 :key="`product-selected-${product.uid}`"
                                 @click="selectedProducts = selectedProducts.filter(selected => selected !== product.uid)">
                                <span class="icon-times-after">{{ product.name }}</span>
                            </div>
                        </template>
                        <div class="selected__item" v-if="!hideIndustryFilter && selectedIndustry != -1 && industries.length" @click="selectedIndustry = -1"><span class="icon-times-after">{{ industries.filter(industry => industry.uid.toString() == selectedIndustry)[0].name }}</span></div>
                        <div class="selected__item" v-if="!hideTypeFilter && selectedType != -1 && types.length" @click="selectedType = -1"><span class="icon-times-after">{{ types.filter(type => type.uid.toString() == selectedType)[0].name }}</span></div>
                    </div>
                    <div class="selected__reset">
                        <span class="link" @click="reset()"><span>{{ $t('search.reset') }}</span></span>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-wrapper -max-width-limited">
            <div class="module-mediacentres">
                <div class="mediacentres-wrapper">
                    <template v-if="!initialized || !mediacentresLoad">
                        <div class="mediacentre__item mediacentre__item--loading" v-for="n in currentPage * itemsPerPage" :key="n">
                            <div class="item__image">
                                <span class="preloader-image"></span>
                            </div>
                            <div class="item__content">
                                <div class="content__headline">
                                    <span class="preloader-text"></span>
                                </div>
                            </div>
                        </div>
                    </template>
                    <template v-else>
                        <template v-for="(item, index) in mediacentres">
                            <Item v-bind:item="item" v-bind:key="index"></Item>
                        </template>
                        <div v-if="mediacentres.length === 0">
                            {{ $t('search.no-results') }}
                        </div>

                    </template>
                    <div class="mediacentre__item mediacentre__item--placeholder"></div>
                </div>
            </div>
        </div>
        <div class="col-wrapper -max-width-limited" v-if="numberOfTotalItems">
            <div class="col">
                <div class="content-item module-load-more">
                    <div class="load-more__button" v-if="currentPage < numberOfPages">
                        <div class="btn -btn-alpha" @click="loadMore">
                            <span>{{ $t('loadMore.btn') }}</span>
                        </div>
                    </div>
                    <div class="load-more__progress" v-if="initialized">
                        <div class="progress__info">
                            <span class="meta" v-html="$t('loadMore.info', { current: mediacentres.length, total: numberOfTotalItems })"></span>
                        </div>
                        <div class="progress__bar"><span :style="{ width: (mediacentres.length / numberOfTotalItems * 100) + '%' }"></span></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import CheckboxFilter from '@/components/CheckboxFilter'
import Item from '@/components/Item'

export default {
    data ()
    {
        return {
            isFetchingData: false,
            hideProductFilter: window.app.mediacentre_list.hideProductFilter === '1',
            hideIndustryFilter: window.app.mediacentre_list.hideIndustryFilter === '1',
            hideTypeFilter: window.app.mediacentre_list.hideTypeFilter === '1'
        }
    },
    computed: {
        selectedProducts: {
            get ()
            {
                return this.$store.state.products.selected
            },
            set (payload)
            {
                this.$store.commit('products/setSelected', payload)
                if (!this.isFetchingData) this.filter()
            }
        },
        selectedIndustry: {
            get ()
            {
                return this.$store.state.industries.selected
            },
            set (payload)
            {
                this.$store.commit('industries/setSelected', payload)
                if (!this.isFetchingData) this.filter()
            }
        },
        selectedType: {
            get ()
            {
                return this.$store.state.types.selected
            },
            set (payload)
            {
                this.$store.commit('types/setSelected', payload)
                if (!this.isFetchingData) this.filter()
            }
        },
        mutatedProducts ()
        {
            const products = this.products
            const categories = []
            products.forEach(product =>
            {
                if (product.category && !categories.includes(product.category.name)) categories.push(product.category.name)
            })
            const mutatedProducts = []
            categories.forEach(category =>
            {
                mutatedProducts.push({
                    title: category,
                    options: products.filter(product => product.category && product.category.name === category)
                })
            })
            if (mutatedProducts.length !== 1)
            {
                mutatedProducts.push({
                    title: this.$i18n.t('search.productDefaultCategory'),
                    options: products.filter(product => !product.category)
                })
            }
            return mutatedProducts
        },
        ...mapState({
            initialized: state => state.initialized,
            filtersFixed: state => state.filtersFixed,
            products: state => state.products.items,
            industries: state => state.industries.items,
            types: state => state.types.items,
            mediacentres: state => state.mediacentres.items,
            mediacentresLoad: state => state.mediacentres.loaded,
            currentPage: state => state.mediacentres.currentPage,
            itemsPerPage: state => state.mediacentres.itemsPerPage,
            numberOfPages: state => state.mediacentres.numberOfPages,
            numberOfTotalItems: state => state.mediacentres.numberOfTotalItems
        })
    },
    components: {
        CheckboxFilter,
        Item
    },
    methods: {
        reset: function ()
        {
            this.isFetchingData = true
            if (!this.hideIndustryFilter) this.selectedIndustry = -1
            if (!this.hideTypeFilter) this.selectedType = -1
            if (!this.hideProductFilter) this.selectedProducts = []
            this.isFetchingData = false
            this.filter()
        },
        ...mapActions([
            'init',
            'filter',
            'loadMore'
        ])
    },
    created ()
    {
        this.init()
    }
}
</script>
